import { useState, useEffect, useRef } from "react";
import { toast } from "sonner";
import { adminApi } from "../../api";

/**
 * Polls backfill status every 5s. When a running job finishes, fires `onFinished` (page reloads list).
 */
export default function useMediaBackfill({ tipo, onFinished }) {
  const [backfill, setBackfill] = useState(null);
  const [backfillLimit, setBackfillLimit] = useState("");
  const [backfillForce, setBackfillForce] = useState(false);
  const [backfillStarting, setBackfillStarting] = useState(false);

  const pollRef = useRef(null);
  const prevRunning = useRef(false);

  const fetchBackfill = async () => {
    try {
      const s = await adminApi.summaryBackfillStatus();
      setBackfill(s);
      return s;
    } catch (e) {
      if (process.env.NODE_ENV !== "production") {
        console.warn("useMediaBackfill: status fetch failed", e);
      }
      return null;
    }
  };

  useEffect(() => {
    fetchBackfill();
    pollRef.current = setInterval(fetchBackfill, 5000);
    return () => {
      if (pollRef.current) clearInterval(pollRef.current);
    };
  }, []);

  // When backfill finishes, fire onFinished
  useEffect(() => {
    if (prevRunning.current && backfill && !backfill.running) {
      onFinished?.();
    }
    prevRunning.current = !!backfill?.running;
  }, [backfill?.running, onFinished]);

  const startBackfill = async () => {
    setBackfillStarting(true);
    try {
      const params = { tipo, force: backfillForce };
      if (backfillLimit && parseInt(backfillLimit, 10) > 0) {
        params.limit = parseInt(backfillLimit, 10);
      }
      const r = await adminApi.summaryBackfillStart(params);
      if (r.status === "started") {
        toast.success("Backfill iniciado");
        fetchBackfill();
      } else if (r.status === "already_running") {
        toast.info("Já existe um backfill a correr");
      } else {
        toast.error(r.error || "Falha ao iniciar");
      }
    } catch (e) {
      toast.error(e.message || "Falha ao iniciar");
    }
    setBackfillStarting(false);
  };

  const stopBackfill = async () => {
    try {
      await adminApi.summaryBackfillStop();
      toast.info("Pedido de paragem enviado. Termina o item actual.");
      fetchBackfill();
    } catch (e) {
      toast.error(e.message || "Erro");
    }
  };

  return {
    backfill, backfillLimit, setBackfillLimit, backfillForce, setBackfillForce,
    backfillStarting, startBackfill, stopBackfill,
  };
}
